import { AUTH_PERMISSIONS } from '@lib/constants';
import Cookies from 'js-cookie';

export const getPermissions = () => {
  if (typeof window === undefined) {
    return null;
  }
  return Cookies.get(AUTH_PERMISSIONS);
};
